import alloy from '@alloyidentity/web-sdk';
import { Alloy } from '@alloyidentity/web-sdk/dist/types';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Store } from '@ngrx/store';
import MgiRiskAngularSdkInstance from 'mgiriskangularsdk';
import { Subject } from 'rxjs';
import { ErrorService } from 'src/app/services/error.service';
import { SetRisk } from 'src/app/store/auth/auth.actions';
import { RiskStatus } from 'src/app/store/auth/auth.model';
import { selectRisk } from 'src/app/store/auth/auth.selectors';

@Component({
    selector: 'app-risk-sdk',
    templateUrl: './risk-sdk.component.html',
    styleUrls: ['./risk-sdk.component.scss'],
    standalone: false
})
export class RiskSdkComponent {
  @Output() riskSdkCompleteEvent = new EventEmitter<void>()
  @Output() riskSdkErrorEvent = new EventEmitter<void>()
  @Input() steps: { [id: string]: number }
  @Input() set currentStep(currentStep: number) {
    if (this.steps && currentStep === this.steps['riskSdk']) {
      setTimeout(() => {  
        this.handleOpen()
      }, 300) // Todo: Tim: #may6 - this is kind of a #hack, should revisit
    }
  }

  private riskSDKPayload: any
  @Input() public set riskStatus(riskStatus: RiskStatus) {
    if (riskStatus?.compliancePayload && !this.alloySDK) { // Risk SDK
      this.riskSDKPayload = riskStatus.compliancePayload
      this.initializeAlloySDK()
    }
  } 

  @Input() cmsLabels: any // Todo: Tim: fix types

  private destroy$: Subject<void> = new Subject<void>()

  public timerClickSubject: Subject<string> = new Subject()

  public isOpen: boolean = false;
  private alloySDK: any // Todo: revert:
  public risk: 'ALLOW' | 'DECLINE' | 'WAIT' | null = null

  constructor(
    private sanitizer: DomSanitizer, 
    private errorService: ErrorService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.store.select(selectRisk).subscribe((risk) => {
      this.risk = risk
      if (this.risk) {
        console.log('risk-sdk - starting timer...') // remove: Tim: #may6
        setTimeout(() => {  // Add small delay to ensure child component is ready
          this.timerClickSubject.next('start')
        }, 100) // Todo: Tim: #may6 - this is kind of a #hack, should revisit
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  // --------------------------------------------------------------------

  // public async initializeAlloySDK(): Promise<void> {
  //   // const sdkPayloadParams = {
  //   //   key: "b11d8557-647d-4213-9924-e811605cf5db", // SDK key from Dashboard
  //   //   journeyToken: "J-xcYJS1mAOAwxJpWKOZIA", // Journey token from account
  //   //   journeyApplicationToken: "JA-3U9qz9WTr0jGPD5ZzjhD", // Application token from Alloy
  //   //   production: false,
  //   //   apiUrl:"https://shared-prod-ue1-02-alloysdk.api.alloy.com/",
  //   //   appUrl:"https://shared-prod-ue1-02-alloysdk.app.alloy.com/",
  //   // }

  //   // const sdkPayloadParams = {
  //   //   key: "b11d8557-647d-4213-9924-e811605cf5db", // SDK key from Dashboard
  //   //   journeyToken: "J-xcYJS1mAOAwxJpWKOZIA", // Journey token from account
  //   //   journeyApplicationToken: "JA-jDCAA7rRmC0Wdv4eNFO5", // Application token from Alloy
  //   //   production: false,
  //   //   apiUrl:"https://shared-prod-ue1-02-alloysdk.api.alloy.com/",
  //   //   appUrl:"https://shared-prod-ue1-02-alloysdk.app.alloy.com/",
  //   // }

  //   // {
  //   //   "digitalProfileId": "14721950",
  //   //   "isStepUpRequired": true,
  //   //   "isRedirectRequired": false,
  //   //   "compliancePayload": "{\"key\":\"06d6bec3-d9a4-4afa-bf87-038d785e3d27\",\"journeyToken\":\"J-xcYJS1mAOAwxJpWKOZIA\",\"journeyApplicationToken\":\"JA-jDCAA7rRmC0Wdv4eNFO5\",\"production\":false,\"appURL\":\"https://shared-prod-ue1-02-alloysdk.app.alloy.com\",\"apiURL\":\"https://shared-prod-ue1-02-alloysdk.api.alloy.com\"}",
  //   //   "profileVerification": false
  //   // }

    
  //   const sdkPayloadParams = { // cipreview
  //     key: "06d6bec3-d9a4-4afa-bf87-038d785e3d27", // SDK key from Dashboard
  //     journeyToken: "J-xcYJS1mAOAwxJpWKOZIA", // Journey token from account
  //     journeyApplicationToken: "JA-7mfrIWvrhfAoImtUy93v", // Application token from Alloy
  //     production: false,
  //     apiUrl:"https://shared-prod-ue1-02-alloysdk.api.alloy.com/",
  //     appUrl:"https://shared-prod-ue1-02-alloysdk.app.alloy.com/",
  //   }

  //   // const sdkPayloadParams = {
  //   //   key: "b11d8557-647d-4213-9924-e811605cf5db", // SDK key from Dashboard
  //   //   journeyToken: "J-xcYJS1mAOAwxJpWKOZIA", // Journey token from account
  //   //   journeyApplicationToken: "JA-3U9qz9WTr0jGPD5ZzjhD", // Application token from Alloy
  //   //   production: false,
  //   //   apiUrl:"https://shared-prod-ue1-02-alloysdk.api.alloy.com",
  //   //   appUrl:"https://shared-prod-ue1-02-alloysdk.app.alloy.com",
  //   // }

  //   console.log('sdkPayloadParams', sdkPayloadParams) // todo: remove: #may6

  //   try {
  //     this.alloySDK.init(sdkPayloadParams).then((res: any) => {
  //       // alloy.init(sdkPayloadParams).then((res: any) => {
  //       console.log("****** res-->", res)
  //     })
  //   }
  //   catch (error) {
  //     console.error('Alloy SDK initialization failed:', error)
  //   }
  // }
  
  // public handleOpen(): void {
  //   console.log('**handleOpen - this.alloySDK', this.alloySDK); // Todo: Remove: #may6
  //   if (this.alloySDK) {
  //     this.alloySDK.open(this.callback, 'renderComponent')
  //     this.isOpen = true
  //   }
  //   else {
  //     console.error('ERR: handleOpen - Alloy SDK not initialized.')
  //   }
  // }

  // public handleClose(): void {
  //   if (this.alloySDK) {
  //       alloy.close();
  //       this.isOpen = false;
  //   } else {
  //     console.error('ERR: handleCloseAlloy SDK not initialized.')
  //   }
  // }

  // callback = (data: any): void => {
  //   console.log("Callback data:", data); // Todo: #may6 - can we remove: this?
  //   if (data.status === 'completed') {
  //     this.riskSdkCompleteEvent.emit()
  //   }
  //   // const status = alloy.getStatus(data)
  //   // if (data.sdk.sdkEvent === 'exit') {
  //   //   this.isOpen = false;  // Set `isOpen` to `false` when the modal is exited
  //   //   // Todo: Tim: #may6 #critical - Need to setup specific cases on how to handle completion of RIsk SDK, based on API response.
  //   //   if (status === 'ALLOW' || status === 'WAIT') {
  //   //     this.riskSdkCompleteEvent.emit()
  //   //   }
  //   //   else if (status === 'NOT_ALLOW') {
  //   //     // Todo: Tim: #may6 - handle NOT-ALLOW status
  //   //     this.errorService.open('_unable to verify identity', this.cmsLabels.stellar.dismiss)
  //   //   }
  //   //   else {
  //   //     // Todo: Tim: #may6 - fix routing if status is not available
  //   //     // this.errorService.open('_ERROR', this.cmsLabels.stellar.dismiss) // Todo: #may6 - revert
  //   //     console.error('Error during id verification')
  //   //     this.riskSdkCompleteEvent.emit() // Todo: remove: #may6
  //   //   }
  //   // }
  // }

  // --------------------------------------------------------------------

  public async initializeAlloySDK(): Promise<void> {
    // const sdkPayloadParams = { // Todo: #codeCleanup #may6
    //   key: "06d6bec3-d9a4-4afa-bf87-038d785e3d27", // SDK key from Dashboard
    //   journeyToken: "J-xcYJS1mAOAwxJpWKOZIA", // Journey token from account
    //   journeyApplicationToken: "JA-S5uJd7Q8yHR3By2b9Sh5", // Application token from Alloy
    //   production: false,
    //   apiUrl:"https://shared-prod-ue1-02-alloysdk.api.alloy.com/",
    //   appUrl:"https://shared-prod-ue1-02-alloysdk.app.alloy.com/",
    // }

    // const sdkPayloadParams = "{\"key\":\"06d6bec3-d9a4-4afa-bf87-038d785e3d27\",\"journeyToken\":\"J-xcYJS1mAOAwxJpWKOZIA\",\"journeyApplicationToken\":\"JA-uxqS61KarQjIo7U00CcR\",\"production\":false,\"appURL\":\"https://shared-prod-ue1-02-alloysdk.app.alloy.com/\",\"apiURL\":\"https://shared-prod-ue1-02-alloysdk.api.alloy.com/\"}"
    // const sdkPayloadParams = "{\"key\":\"38b8f002-f062-475e-98d5-75785fa68f60\",\"journeyToken\":\"J-xcYJS1mAOAwxJpWKOZIA\",\"journeyApplicationToken\":\"JA-S5uJd7Q8yHR3By2b9Sh5\",\"production\":false,\"appURL\":\"https://shared-prod-ue1-02-alloysdk.app.alloy.com/\",\"apiURL\":\"https://shared-prod-ue1-02-alloysdk.api.alloy.com/\"}"
    // const sdkPayloadParams = "{\"key\":\"06d6bec3-d9a4-4afa-bf87-038d785e3d27\",\"journeyToken\":\"J-xcYJS1mAOAwxJpWKOZIA\",\"journeyApplicationToken\":\"JA-7mfrIWvrhfAoImtUy93v\",\"production\":false,\"appURL\":\"https://shared-prod-ue1-02-alloysdk.app.alloy.com/\",\"apiURL\":\"https://shared-prod-ue1-02-alloysdk.api.alloy.com/\"}"
    // const sdkPayloadParams = "{\"key\":\"06d6bec3-d9a4-4afa-bf87-038d785e3d27\",\"journeyToken\":\"J-xcYJS1mAOAwxJpWKOZIA\",\"journeyApplicationToken\":\"JA-7mfrIWvrhfAoImtUy93v\",\"production\":false,\"appURL\":\"https://shared-prod-ue1-02-alloysdk.app.alloy.com/\",\"apiURL\":\"https://shared-prod-ue1-02-alloysdk.api.alloy.com/\"}"
    // const sdkPayloadParams = "{\n  \"key\": \"06d6bec3-d9a4-4afa-bf87-038d785e3d27\", \n  \"journeyToken\": \"J-xcYJS1mAOAwxJpWKOZIA\", \n  \"journeyApplicationToken\": \"JA-7mfrIWvrhfAoImtUy93v\", \n  \"production\": false,\n  \"apiUrl\": \"https://shared-prod-ue1-02-alloysdk.api.alloy.com/\",\n  \"appUrl\": \"https://shared-prod-ue1-02-alloysdk.app.alloy.com/\"\n}"
    // const sdkPayloadParams = '{"key":"06d6bec3-d9a4-4afa-bf87-038d785e3d27","journeyToken":"J-xcYJS1mAOAwxJpWKOZIA","journeyApplicationToken":"JA-7mfrIWvrhfAoImtUy93v","production":false,"appURL":"https://shared-prod-ue1-02-alloysdk.app.alloy.com/","apiURL":"https://shared-prod-ue1-02-alloysdk.api.alloy.com/"}'




    // const sdkPayloadParams = { // cipreview
    //   key: "06d6bec3-d9a4-4afa-bf87-038d785e3d27", // SDK key from Dashboard
    //   journeyToken: "J-xcYJS1mAOAwxJpWKOZIA", // Journey token from account
    //   journeyApplicationToken: "JA-7mfrIWvrhfAoImtUy93v", // Application token from Alloy
    //   production: false,
    //   apiUrl:"https://shared-prod-ue1-02-alloysdk.api.alloy.com/",
    //   appUrl:"https://shared-prod-ue1-02-alloysdk.app.alloy.com/",
    // }

    const alloyInitParams = {
      isReactNative: false,
      debugMode: false,
      actionProvider: "ALLOY",
      providerSdkPayload: this.riskSDKPayload // Todo: revert
      // providerSdkPayload: JSON.stringify(sdkPayloadParams)
      // providerSdkPayload: sdkPayloadParams
    }

    // console.log('alloyInitParams', alloyInitParams) // Todo: remove: #may6
    try {
      this.alloySDK = await MgiRiskAngularSdkInstance.initialize(alloyInitParams)
      // console.log('this.alloySDK', this.alloySDK)
    }
    catch (error) {
      console.error('Alloy SDK initialization failed:', error)
    }
  }

  public handleOpen(): void {
    if (this.alloySDK) {
      try {
        const anchorElementId = 'renderComponent';
        MgiRiskAngularSdkInstance.open(this.callback, anchorElementId);
        this.isOpen = true;  // Mark modal as open
      } catch (error) {
        console.error('Failed to open Alloy modal:', error);
      }
    } else {
      console.error('Alloy SDK not initialized.');
    }
  }

  public handleClose(): void {
    if (this.alloySDK) {
      try {
        MgiRiskAngularSdkInstance.close();
        this.isOpen = false;
      } catch (error) {
        console.error('Failed to close Alloy modal:', error);
      }
    } else {
      console.error('Alloy SDK not initialized.');
    }
  }

  
  callback = (data: any): void => {
    // console.log("Callback data:", data); // Todo: #may6 - can we remove: this?
    console.log('MgiRiskAngularSdkInstance', MgiRiskAngularSdkInstance) // Todo: remove: #may6
    // Todo: Tim: #may6 #critical - temporary function, directly using the status from the data object
    const status = this.getStatus(data)
    // const status = MgiRiskAngularSdkInstance.getStatus(data)
    console.log('status', status)  // Log status of the modal event
    // if (data.sdk.sdkEvent === 'exit') { // Todo: Tim: #may6 #critical - temporary navigation for dev
    //   this.isOpen = false
    //   this.store.dispatch(SetRisk({ risk: 'ALLOW' })) 
    // }
    if (data.sdk.sdkEvent === 'close') {
      this.isOpen = false
      if (status === 'ALLOW' || status === 'WAIT') {
        // console.log('risk-sdk completed ALLOW/WAIT- emitting riskSdkCompleteEvent') // remove: Tim: #may6
        this.store.dispatch(SetRisk({ risk: status }))
      }
      else if (status === 'DECLINE') {
        // console.log('risk-sdk NOT_ALLOW/DECLINE - returning to landing page:', status) // remove: Tim: #may6
        this.store.dispatch(SetRisk({ risk: status }))
        this.riskSdkErrorEvent.emit()
        this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss)
      }
      else {
        console.error('Error during id verification')
        // console.log('risk-sdk ERROR - returning to landing page'); // remove: Tim: #may6
        this.riskSdkErrorEvent.emit()
        this.errorService.open(this.cmsLabels.stellar.error.somethingHasGoneWrong, this.cmsLabels.stellar.dismiss)
      }
    }
  }

  public emitTimerCompleteEvent() {
    if (this.risk === 'ALLOW' || this.risk === 'WAIT') {
      this.riskSdkCompleteEvent.emit()
    }
    else {
      this.riskSdkErrorEvent.emit()
    }
  }



  // Todo: Tim: #may6 #critical - temporary function, directly using the status from the data object
  getStatus(data: any): string {
      const status = data?.complete_outcome?.toLowerCase() ?? ''
      if (status === 'approved') return 'ALLOW'
      if (status === 'denied') return 'DECLINE'
      return 'WAIT'
  }
}

